import { DataTable } from 'common/data-table';
import DataTablePagination from 'common/data-table-pagination';
import { useFetchApiList } from 'hooks/api';
import Loading from 'common/ui/loading';
import { Text } from 'common/ui/text';
import { CirclePlus } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Button } from '../button';

const AdminList = ({
  title,
  description,
  apiCall,
  createUrl,
  resourceName,
  FilterForm,
  renderRightHeader,
  columnsGenerator,
  ...props
}) => {
  const pageParams = useParams();
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(searchParams.entries());

  const allParams = { ...pageParams, ...queryParams };

  const { data, paging, isLoading, isLoadingMore, load, error } = useFetchApiList(apiCall.list, {
    resourceName: resourceName || 'data',
  });

  useEffect(() => {
    load(allParams);
  }, [JSON.stringify(allParams)]);

  if (isLoading || isLoadingMore) {
    return (
      <div className="flex justify-center items-center h-[80vh]">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div>Error: {JSON.stringify(error)}</div>;
  }
  return (
    <div>
      <div className="flex justify-between">
        <div>
          <Text variant="h2" className="mt-0">
            {title}
          </Text>
          {description && (
            <p className="text-sm text-muted-foreground -mt-2 mb-2">{description}</p>
          )}
        </div>
        <div className="flex flex-wrap gap-4">
          {renderRightHeader && renderRightHeader()}
          {createUrl && (
            <Button
              asChild
              variant="outline"
              size="icon"
              className="relative border-2 border-primary bg-white hover:bg-gray-100"
              aria-label={'user create'}
            >
              <Link to={createUrl}>
                <CirclePlus className="text-primary" strokeWidth={3} />
              </Link>
            </Button>
          )}
        </div>
      </div>
      <DataTable
        columns={columnsGenerator(pageParams)}
        FilterForm={FilterForm}
        data={data || []}
        {...props}
      />
      {paging && <DataTablePagination paging={paging} />}
    </div>
  );
};

export default AdminList;
